module.exports = __webpack_public_path__ + "img/telemedicina.1792a26b.jpg";